/**
 * Created by rickborst on 25/04/2017.
 */

/**
 * Converts media data from read data.
 *
 * @param {Object} [data] - Read data.
 * @returns {Object} Media data.
 */
export function convertFromRead (data = {}) { // eslint-disable-line no-unused-vars

    // TODO: Implement this.
    return {};
}


// WEBPACK FOOTER //
// ./src/js/datasources/kaltura/adapters/assets/media.js